module.exports = __webpack_public_path__ + "img/twbgsch_icon.e1dd5b2f.png";